module.exports = "<div style=\"display: inline-block;\">\n  <button #buttonNode\n          class=\"btn btn-sm {{btnClass}}\"\n          (click)=\"localOnClick()\">\n    <ng-content></ng-content>\n    <i *ngIf=\"plus\"\n       class=\"fa fx-2x fa-plus\"></i>\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/nv-button/nv-button.component.html
// module id = ../../../../../src/app/components/nv-button/nv-button.component.html
// module chunks = 0